import React from 'react';
import { Button } from '@cherre-frontend/ui';
import { CustomPropertyAttribute } from '../../types/CustomPropertyAttribute';
import { CustomAttributesList } from './CustomAttributesList';

interface ArchivedCustomAttributesTabProps {
  archivedAttributes: CustomPropertyAttribute[];
  onRestoreAttribute: (slug: string) => void;
  onMoveAttribute: (fromAttributeSlug: string, toAttributeSlug: string) => void;
}

export const ArchivedCustomAttributesTab = ({
  archivedAttributes,
  onRestoreAttribute,
  onMoveAttribute,
}: ArchivedCustomAttributesTabProps) => {
  return (
    <CustomAttributesList
      attributes={archivedAttributes}
      onMoveAttribute={onMoveAttribute}
      renderActions={(attribute) => (
        <Button
          size='small'
          color='primary'
          variant='text'
          onClick={() => onRestoreAttribute(attribute.slug)}
        >
          Re-Activate
        </Button>
      )}
    />
  );
};
